import _extends from "@babel/runtime/helpers/extends";
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import * as React from 'react';
import classnames from 'classnames';
import { loader } from '@monaco-editor/react';
import { Box, Grid, formilyCore } from '@alife/cn-ui';
import { groupBy, uniqWith, isArray, isEqual, find, isNil } from 'lodash-es';
import ReactionArrayForm from "../components/reaction-array-form";
import { REACTION_CONFIG_LAYOUT } from "../const";
import { isFormHooks, isNoValueCondition } from "../utils";
import "../style/index.scss";
loader.config({
  paths: {
    vs: 'https://g.alicdn.com/code/lib/monaco-editor/0.33.0/min/vs'
  }
});
var createForm = formilyCore.createForm,
  onFieldReact = formilyCore.onFieldReact,
  onFormValuesChange = formilyCore.onFormValuesChange;
export var FieldsOptionContext = /*#__PURE__*/React.createContext([]);

// const getRealCondition = (condition, conditionValue) => `${condition?.replace('${conditionValue}', `'${conditionValue}'`)}`;

// 根据条件生成run函数
// 包括多条语句指令
// const generateRunFunction = (source) => {
//   const { field, state, condition, conditionValue, data } = source;
//   const realCondition = getRealCondition(condition, conditionValue);
//
//   const { fromDataSource, syncData } = data || InitData;
//
//   if (!isEmpty(data) && state === 'value') {
//     // 将data转为json；
//     const option = 'const option = $self?.getState().dataSource?.find?.(i => i.value === $self.value) ?? {}';
//     const formatSyncData = syncData.replace(/"\$DS(.*)\b"/g, (match, a) => 'option' + a) || '{}';
//     let result = `${option};const data = Object.assign(${fromDataSource ? 'option' : '{}'},${formatSyncData});`;
//
//     field.forEach(f => {
//       result += `$form.setFieldState('*(${f})', { 'value': ${realCondition} ? data.${f} : '' });`;
//     });
//
//     return result;
//   }
//
//   return `$form.setFieldState('*(${field?.join(',')})', { '${state}': ${realCondition} });`;
// };

// 将表单值转为多条件的Reactions表达式
var formValues2SchemaWithMulCondition = function formValues2SchemaWithMulCondition(validReactions) {
  // 多条件时，需要将conditions遍历、打平为单条件；同时构建logic数组，用于维护逻辑关系
  var realReactions = [];
  validReactions.forEach(function (reactions, groupKey) {
    var reaction = reactions.reaction,
      conditions = reactions.conditions;
    if (isArray(conditions)) {
      conditions.forEach(function (condition) {
        // 长度等于1时 说明是单条件；否则为多条件
        realReactions.push(_extends({
          reaction: reaction,
          groupKey: groupKey
        }, condition, {
          logic: conditions
        }));
      });
    } else {
      // 如果不是conditions结构，说明是旧版单条件Schema，此时需要将最初的reactions push进去
      realReactions.push(reactions);
    }
  });

  // 将筛选出的联动配置按照watchCode进行聚合。表单钩子时，watchCode为空，需要以""作为聚合的key
  var groupWithWatchCode = groupBy(realReactions, function (value) {
    return value.watchCode ? value.watchCode : '';
  });
  var result = [];
  Object.keys(groupWithWatchCode).forEach(function (watchCode) {
    var fieldReactions = [];
    for (var _iterator = _createForOfIteratorHelperLoose(groupWithWatchCode[watchCode]), _step; !(_step = _iterator()).done;) {
      var validReaction = _step.value;
      var reaction = validReaction.reaction,
        _validReaction$condit = validReaction.condition,
        condition = _validReaction$condit === void 0 ? '' : _validReaction$condit,
        _validReaction$condit2 = validReaction.conditionValue,
        conditionValue = _validReaction$condit2 === void 0 ? '' : _validReaction$condit2,
        effects = validReaction.effects,
        groupKey = validReaction.groupKey,
        _validReaction$logic = validReaction.logic,
        logic = _validReaction$logic === void 0 ? [] : _validReaction$logic;
      for (var _iterator2 = _createForOfIteratorHelperLoose(reaction), _step2; !(_step2 = _iterator2()).done;) {
        var item = _step2.value;
        var field = item.field,
          state = item.state,
          data = item.data;
        fieldReactions.push({
          target: "*(" + (field === null || field === void 0 ? void 0 : field.join(',')) + ")",
          effects: [effects],
          fulfill: {
            // 'run': generateRunFunction({ field, state, condition, conditionValue, data }),
            resourcePool: {
              field: field,
              state: state,
              condition: condition,
              conditionValue: conditionValue,
              data: data,
              groupKey: groupKey
            },
            logic: logic
          }
        });
      }
    }
    result.push({
      watchCode: watchCode,
      reactions: fieldReactions
    });
  });
  return result;
};

// 将表单值转为Reactions表达式
var formValues2Schema = function formValues2Schema(values) {
  var reactions = values.reactions;

  // 筛选出存在联动配置的Reactions
  var validReactions = reactions.filter(function (r) {
    return (r === null || r === void 0 ? void 0 : r.reaction) && r.reaction.length > 0 && r.reaction.filter(function (rr) {
      return rr.field && rr.field.length > 0;
    }).length > 0;
  });

  // 判断新旧FormValues
  var hasConditions = !isNil(find(reactions, function (o) {
    return !isNil(o === null || o === void 0 ? void 0 : o.conditions);
  }));
  if (hasConditions) {
    return formValues2SchemaWithMulCondition(validReactions);
  }

  // 将筛选出的联动配置按照watchCode进行聚合。表单钩子时，watchCode为空，需要以""作为聚合的key
  var groupWithWatchCode = groupBy(validReactions, function (value) {
    return value.watchCode ? value.watchCode : '';
  });
  var result = [];
  Object.keys(groupWithWatchCode).forEach(function (watchCode) {
    var fieldReactions = [];
    for (var _iterator3 = _createForOfIteratorHelperLoose(groupWithWatchCode[watchCode]), _step3; !(_step3 = _iterator3()).done;) {
      var validReaction = _step3.value;
      var reaction = validReaction.reaction,
        _validReaction$condit3 = validReaction.condition,
        condition = _validReaction$condit3 === void 0 ? '' : _validReaction$condit3,
        _validReaction$condit4 = validReaction.conditionValue,
        conditionValue = _validReaction$condit4 === void 0 ? '' : _validReaction$condit4,
        effects = validReaction.effects;

      // // 埋点数据 - Hook
      // trace.logCalc({
      //   method: 'sum',
      //   key: `HOOK_${effects}`,
      //   value: 1,
      // })
      //
      // // 埋点数据 - condition
      // trace.logCalc({
      //   method: 'sum',
      //   key: `CONDITION_${condition}`,
      //   value: 1,
      // })

      for (var _iterator4 = _createForOfIteratorHelperLoose(reaction), _step4; !(_step4 = _iterator4()).done;) {
        var item = _step4.value;
        var field = item.field,
          state = item.state,
          data = item.data;
        // 埋点数据 - state
        // trace.logCalc({
        //   method: 'sum',
        //   key: `STATE_${state}`,
        //   value: 1,
        // })

        fieldReactions.push({
          target: "*(" + (field === null || field === void 0 ? void 0 : field.join(',')) + ")",
          effects: [effects],
          fulfill: {
            // 'run': generateRunFunction({ field, state, condition, conditionValue, data }),
            resourcePool: {
              field: field,
              state: state,
              condition: condition,
              conditionValue: conditionValue,
              data: data
            }
          }
        });
      }
    }
    result.push({
      watchCode: watchCode,
      reactions: fieldReactions
    });
  });
  return result;
};

// 将表达式转回表单值
var schema2FormValues = function schema2FormValues(initReactions) {
  var isMul = !isNil(find(initReactions, function (o) {
    var reactions = o.reactions;
    return !isNil(find(reactions, function (r) {
      var _r$fulfill;
      return !isNil(r === null || r === void 0 ? void 0 : (_r$fulfill = r.fulfill) === null || _r$fulfill === void 0 ? void 0 : _r$fulfill.logic);
    }));
  }));
  if (isMul) {
    return mulConditionSchema2FormValues(initReactions);
  }
  var result = [];
  initReactions.forEach(function (item) {
    var watchCode = item.watchCode,
      reactions = item.reactions;

    // 将reactions按照条件(condition, conditionValue)重新分组
    var groupWithRun = groupBy(reactions, function (reaction) {
      var effects = reaction.effects,
        resourcePool = reaction.fulfill.resourcePool;
      var condition = resourcePool.condition,
        conditionValue = resourcePool.conditionValue;
      return condition + "__" + conditionValue + "__" + effects;
    });
    for (var conditionWithEffects in groupWithRun) {
      var _groupWithRun$conditi;
      var _conditionWithEffects = conditionWithEffects.split('__'),
        condition = _conditionWithEffects[0],
        conditionValue = _conditionWithEffects[1],
        effectsString = _conditionWithEffects[2];
      var reaction = (_groupWithRun$conditi = groupWithRun[conditionWithEffects]) === null || _groupWithRun$conditi === void 0 ? void 0 : _groupWithRun$conditi.map(function (r) {
        var resourcePool = r.fulfill.resourcePool;
        var field = resourcePool.field,
          state = resourcePool.state,
          data = resourcePool.data;
        return {
          data: data,
          state: state,
          field: field
        };
      });
      result.push({
        conditions: [{
          watchCode: watchCode,
          effects: effectsString.split(',')[0],
          // 当前仅支持单选，后期有多选需求时，更改为effectsString.split(',')
          condition: condition,
          conditionValue: conditionValue
        }],
        reaction: reaction
      });
    }
  });
  return result;
};

// 将多条件表达式转会表单值
var mulConditionSchema2FormValues = function mulConditionSchema2FormValues(initReactions) {
  var result = [];
  var flatReactions = [];

  // 将外层打散，
  initReactions.forEach(function (watchCodeObj) {
    var watchCode = watchCodeObj.watchCode,
      reactions = watchCodeObj.reactions;
    reactions.forEach(function (reaction) {
      var _reaction$fulfill, _reaction$fulfill$res;
      flatReactions.push(_extends({
        watchCode: watchCode,
        // 将groupKey提到外层，便于后续操作
        groupKey: reaction === null || reaction === void 0 ? void 0 : (_reaction$fulfill = reaction.fulfill) === null || _reaction$fulfill === void 0 ? void 0 : (_reaction$fulfill$res = _reaction$fulfill.resourcePool) === null || _reaction$fulfill$res === void 0 ? void 0 : _reaction$fulfill$res.groupKey
      }, reaction));
    });
  });
  var groupWithGroupKey = groupBy(flatReactions, 'groupKey');
  var _loop = function _loop() {
    var reaction = [],
      conditions = [];
    groupWithGroupKey[groupKey].forEach(function (item) {
      var _item$fulfill = item.fulfill,
        _item$fulfill$resourc = _item$fulfill.resourcePool,
        resourcePool = _item$fulfill$resourc === void 0 ? {} : _item$fulfill$resourc,
        _item$fulfill$logic = _item$fulfill.logic,
        logic = _item$fulfill$logic === void 0 ? [] : _item$fulfill$logic;
      var state = resourcePool.state,
        field = resourcePool.field,
        data = resourcePool.data;
      reaction.push({
        state: state,
        field: field,
        data: data
      });
      logic.forEach(function (logicItem) {
        var operator = logicItem.operator,
          effects = logicItem.effects,
          watchCode = logicItem.watchCode,
          condition = logicItem.condition,
          conditionValue = logicItem.conditionValue;
        conditions.push({
          operator: operator,
          effects: effects,
          watchCode: watchCode,
          condition: condition,
          conditionValue: conditionValue
        });
      });
    });
    result.push({
      reaction: uniqWith(reaction, isEqual),
      conditions: uniqWith(conditions, isEqual)
    });
  };
  for (var groupKey in groupWithGroupKey) {
    _loop();
  }
  return result;
};
export var View = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    onChange = props.onChange,
    _props$reactions = props.reactions,
    initReactions = _props$reactions === void 0 ? [] : _props$reactions,
    _props$fieldsOption = props.fieldsOption,
    fieldsOption = _props$fieldsOption === void 0 ? [] : _props$fieldsOption;
  var ContainerClassNames = classnames('builder-container', className);
  React.useImperativeHandle(ref, function () {
    return {
      getReactions: function getReactions() {
        var result = formValues2Schema(Form.getFormState().values);
        return result;
      }
    };
  });
  var Form = React.useMemo(function () {
    return createForm({
      initialValues: {
        reactions: schema2FormValues(initReactions)
      },
      effects: function effects() {
        onFormValuesChange(function (form) {
          onChange && onChange(formValues2Schema(form.getFormState().values));
        });

        // 旧一对一联动
        onFieldReact('reactions.*.*(watchCode,condition)', function (field) {
          var effectsField = field.query("*." + field.indexes[0] + ".*(effects)").take();
          var isFormEffects = isFormHooks(effectsField === null || effectsField === void 0 ? void 0 : effectsField.value);
          field.setDisplay(isFormEffects ? 'none' : 'visible');
        });
        onFieldReact('reactions.*.*(conditionValue)', function (field) {
          var conditionField = field.query("*." + field.indexes[0] + ".*(condition)").take();
          if (conditionField.getState().display === 'none') {
            field.setDisplay('none');
          } else {
            var hiddenConditionValue = isNoValueCondition(conditionField.getState().value);
            field.setDisplay(hiddenConditionValue ? 'none' : 'visible');
          }
        });

        // 新多对一联动
        onFieldReact('reactions.*.conditions.*.*(watchCode,condition)', function (field) {
          var effectsFieldValue = field.query('..[].effects').value();
          var isFormEffects = isFormHooks(effectsFieldValue);
          field.setDisplay(isFormEffects ? 'none' : 'visible');
        });
        onFieldReact('reactions.*.conditions.*.*(conditionValue)', function (field) {
          var conditionField = field.query('..[].condition').take();
          if (conditionField.getState().display === 'none') {
            field.setDisplay('none');
          } else {
            var hiddenConditionValue = isNoValueCondition(conditionField.getState().value);
            field.setDisplay(hiddenConditionValue ? 'none' : 'visible');
          }
        });
      }
    });
  }, [initReactions, fieldsOption]);
  if (!Box || !Grid || !(Grid !== null && Grid !== void 0 && Grid.Row) || !(Grid !== null && Grid !== void 0 && Grid.Row)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FieldsOptionContext.Provider, {
    value: fieldsOption
  }, /*#__PURE__*/React.createElement("div", {
    className: ContainerClassNames,
    style: style
  }, /*#__PURE__*/React.createElement(Box, {
    direction: 'row',
    align: 'center',
    className: 'header'
  }, /*#__PURE__*/React.createElement(Grid.Row, {
    style: {
      width: '100%'
    }
  }, REACTION_CONFIG_LAYOUT.map(function (config, index) {
    var span = config.span,
      configTitle = config.title;
    var lastOne = index === REACTION_CONFIG_LAYOUT.length - 1;
    return /*#__PURE__*/React.createElement(Grid.Col, {
      span: span,
      key: configTitle
    }, /*#__PURE__*/React.createElement("div", {
      className: 'configTitleItem',
      style: {
        borderRight: lastOne ? 'none' : '2px solid white'
      }
    }, configTitle));
  }))), /*#__PURE__*/React.createElement("div", {
    className: 'content'
  }, /*#__PURE__*/React.createElement(ReactionArrayForm, {
    form: Form,
    name: 'reactions',
    span: REACTION_CONFIG_LAYOUT.map(function (_ref) {
      var span = _ref.span;
      return span;
    })
  }))));
});